var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDifa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddiii_207_77966)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_207_77966)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    width: 48,
    height: 48,
    rx: 12,
    fill: "#289891"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    transform: "translate(3.5)",
    fill: "url(#paint0_linear_207_77966)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_207_77966)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M26.7205 13.894C26.2355 11.8131 25.2495 10.0226 23.7461 8.44184C26.3487 7.82887 28.8866 7.86114 31.4569 8.49023C31.376 10.5065 31.2791 12.4906 31.1982 14.5392C29.7434 14.023 28.2723 13.7649 26.7205 13.894Z",
    fill: "url(#paint1_linear_207_77966)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M32.8316 15.3456C33.6722 13.3938 33.9632 11.3775 33.6883 9.19984C36.1455 10.2483 38.1661 11.7807 39.8473 13.8132C38.5702 15.3778 37.3255 16.9264 36.0323 18.5233C35.1755 17.249 34.141 16.1682 32.8154 15.3456H32.8316Z",
    fill: "url(#paint2_linear_207_77966)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M36.8564 20.0245C38.6831 18.9115 40.0571 17.4113 41.0917 15.4918C42.4981 17.7662 43.274 20.1697 43.5003 22.7989C41.5605 23.3635 39.6369 23.9119 37.6647 24.4765C37.697 22.928 37.4707 21.4601 36.8564 20.0406V20.0245Z",
    fill: "url(#paint3_linear_207_77966)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M37.3416 26.525C39.4754 26.7347 41.4798 26.3799 43.4681 25.4765C43.2095 28.1381 42.3689 30.5254 40.9464 32.7353C39.0551 32.0094 37.1961 31.2835 35.2886 30.5415C36.2585 29.3318 36.9698 28.0252 37.3416 26.525Z",
    fill: "url(#paint4_linear_207_77966)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M33.9793 31.8153C35.5635 33.2348 37.4063 34.1381 39.5401 34.5736C37.7619 36.5738 35.6605 37.9933 33.2034 38.945C32.1203 37.2352 31.0372 35.5576 29.938 33.8316C31.4252 33.4284 32.7831 32.7993 33.9793 31.7992V31.8153Z",
    fill: "url(#paint5_linear_207_77966)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M28.2409 34.1062C28.7097 36.187 29.6958 37.9775 31.183 39.5744C28.5804 40.1713 26.0424 40.139 23.4722 39.4938C23.5692 37.4775 23.6662 35.4934 23.7631 33.4448C25.218 33.9771 26.689 34.2352 28.2409 34.1062Z",
    fill: "url(#paint6_linear_207_77966)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M20.9341 16.3938C19.3014 15.0227 17.4424 14.1677 15.2925 13.7967C17.0222 11.7482 19.059 10.2642 21.4999 9.24792C22.6315 10.9094 23.763 12.5708 24.9108 14.2484C23.4397 14.7001 22.098 15.3614 20.9341 16.3938Z",
    fill: "url(#paint7_linear_207_77966)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M16.3913 20.8306C16.4883 20.8306 17.8138 21.1694 17.9108 21.1855C18.2341 19.8305 18.8807 18.6369 19.7375 17.5561C18.0078 16.8948 18.0563 16.8786 16.3589 16.2334C16.3589 16.2334 15.5992 15.9269 15.583 15.9431C15.874 16.2657 16.7146 17.298 16.7792 18.8304C16.8116 19.7338 16.5691 20.4435 16.3913 20.8468V20.8306Z",
    fill: "url(#paint8_linear_207_77966)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4422 31.977C18.5415 29.5735 19.6569 26.8797 17.3776 25.6376C16.7471 25.3957 15.9389 24.9763 15.4378 24.1536C14.8558 23.2019 14.9851 22.1696 15.0336 21.6857C15.1468 20.3307 15.0336 18.3305 13.9506 15.5076C13.2555 16.6368 12.2855 18.5079 11.8006 20.9759C10.9438 25.3634 12.1562 28.8154 12.4957 29.7025C14.4193 34.7998 18.4445 37.2678 19.7539 38.0582C20.4974 38.4937 21.1441 38.8163 21.6128 39.0099C22.6474 36.6548 22.1463 34.1384 20.5621 32.8641C19.3982 31.9286 17.9757 31.9447 17.4584 31.977H17.4422Z",
    fill: "url(#paint9_linear_207_77966)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0356 27.653C22.9224 26.2012 23.9893 24.943 25.4119 24.8301C26.8506 24.7172 28.1114 25.7657 28.2569 27.2013C28.4186 28.6853 27.287 30.0241 25.7837 30.1209C24.345 30.2016 23.1487 29.137 23.0356 27.6691V27.653Z",
    fill: "url(#paint10_linear_207_77966)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0795 31.1855C20.2874 31.25 19.6246 30.7016 19.56 29.9273C19.4953 29.1369 20.0288 28.4756 20.8209 28.4111C21.6453 28.3304 22.3566 28.9111 22.4051 29.7176C22.4535 30.4919 21.8716 31.1371 21.0795 31.2016V31.1855Z",
    fill: "url(#paint11_linear_207_77966)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5827 24.653C22.1624 25.7337 21.3541 26.2822 20.1256 25.9273C18.994 25.6047 18.4767 24.7336 18.7354 23.6045C19.0263 22.4108 19.9477 21.8462 21.1601 22.1366C22.3725 22.4269 22.8413 23.3141 22.5827 24.6368V24.653Z",
    fill: "url(#paint12_linear_207_77966)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 1,
    width: 46,
    height: 46,
    rx: 11,
    stroke: "url(#paint13_linear_207_77966)",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddiii_207_77966",
    x: 0.5,
    y: -3,
    width: 54,
    height: 57,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.162923 0 0 0 0 0.162923 0 0 0 0 0.162923 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_207_77966"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_207_77966"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.164706 0 0 0 0 0.164706 0 0 0 0 0.164706 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_207_77966",
    result: "effect2_dropShadow_207_77966"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_207_77966",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_207_77966"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow_207_77966",
    result: "effect4_innerShadow_207_77966"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect5_innerShadow_207_77966"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_innerShadow_207_77966",
    result: "effect5_innerShadow_207_77966"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_207_77966",
    x: 7.04541,
    y: 2.52272,
    width: 40.9092,
    height: 47.8909,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.5,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_207_77966"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.141176 0 0 0 0 0.141176 0 0 0 0 0.141176 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_207_77966"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_207_77966",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_207_77966",
    x1: 24,
    y1: 5.96047e-7,
    x2: 26,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_207_77966",
    x1: 27.6015,
    y1: 7.99977,
    x2: 27.6015,
    y2: 14.5392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_207_77966",
    x1: 36.3314,
    y1: 9.19984,
    x2: 36.3314,
    y2: 18.5233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_207_77966",
    x1: 40.1784,
    y1: 15.4918,
    x2: 40.1784,
    y2: 24.4765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_207_77966",
    x1: 39.3784,
    y1: 25.4765,
    x2: 39.3784,
    y2: 32.7353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_207_77966",
    x1: 34.739,
    y1: 31.7992,
    x2: 34.739,
    y2: 38.945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_207_77966",
    x1: 27.3276,
    y1: 33.4448,
    x2: 27.3276,
    y2: 40.0008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_207_77966",
    x1: 20.1016,
    y1: 9.24792,
    x2: 20.1016,
    y2: 16.3938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_207_77966",
    x1: 17.6602,
    y1: 15.9425,
    x2: 17.6602,
    y2: 21.1855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_207_77966",
    x1: 16.8272,
    y1: 15.5076,
    x2: 16.8272,
    y2: 39.0099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_207_77966",
    x1: 25.6498,
    y1: 24.8218,
    x2: 25.6498,
    y2: 30.1252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_207_77966",
    x1: 20.9813,
    y1: 28.4036,
    x2: 20.9813,
    y2: 31.2016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_207_77966",
    x1: 20.6607,
    y1: 22.0615,
    x2: 20.6607,
    y2: 26.0348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_207_77966",
    x1: 27.5,
    y1: 0,
    x2: 27.5,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_207_77966"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    width: 48,
    height: 48,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDifa);
export default __webpack_public_path__ + "static/media/difa.d79001926729687aeeb026da12ee369f.svg";
export { ForwardRef as ReactComponent };